import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const MathLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M168.4 283.3l-34.8 9.1c-9 2.4-18.2-3-20.5-12l-9-34.5c-2.4-9 3-18.2 12-20.5l34.8-9.1c9-2.4 18.2 3 20.5 12l9 34.5c2.4 8.9-3 18.1-12 20.5z"
      />
      <image
        width="56"
        height="56"
        x="114.5"
        y="227"
        transform="rotate(-14.67 142.5 255)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M247.8 288.7l-34.9-2.9c-9.5-.8-16.6-9.2-15.9-18.7l2.8-34.5c.8-9.5 9.2-16.6 18.7-15.9l34.9 2.9c9.5.8 16.6 9.2 15.9 18.7l-2.8 34.5c-.8 9.6-9.2 16.7-18.7 15.9z"
      />
      <image
        width="56"
        height="56"
        x="205"
        y="225"
        transform="rotate(4.72 233 253)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M333.8 286.9L299 284c-9.5-.8-16.6-9.2-15.9-18.7l2.8-34.5c.8-9.5 9.2-16.6 18.7-15.9l34.9 2.9c9.5.8 16.6 9.2 15.9 18.7l-2.8 34.5c-.8 9.6-9.2 16.7-18.8 15.9z"
      />
      <image
        width="56"
        height="56"
        x="291.5"
        y="223"
        transform="rotate(4.72 319.5 251)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(-10, -40)"
    >
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M100.2 340.7l-34.5 14.5c-8.2 3.5-17.6-.4-21.1-8.6l-14.4-34.2c-3.5-8.2.4-17.6 8.6-21.1l34.5-14.5c8.2-3.5 17.6.4 21.1 8.6l14.4 34.2c3.5 8.2-.4 17.7-8.6 21.1z"
      />
      <image
        width="56"
        height="56"
        x="41.7"
        y="288"
        transform="rotate(-22.83 69.7 316)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M184.4 369.6l-35.2 9.1c-8.9 2.3-18-3.1-20.3-12l-9-34.9c-2.3-8.9 3.1-18 12-20.3l35.2-9.1c8.9-2.3 18 3.1 20.3 12l9 34.9c2.2 8.9-3.1 18-12 20.3z"
      />
      <image
        width="56"
        height="56"
        x="130.4"
        y="313"
        transform="rotate(-14.47 158.4 341)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <path
        fill="#FFF"
        stroke="#E11E52"
        strokeMiterlimit="10"
        strokeWidth="4"
        d="M259.2 368.6l-37.3-6.6c-8.6-1.5-14.4-9.8-12.9-18.4l6.5-36.9c1.5-8.6 9.8-14.4 18.4-12.9l37.3 6.6c8.6 1.5 14.4 9.8 12.9 18.4l-6.5 36.9c-1.5 8.7-9.8 14.5-18.4 12.9z"
      />
      <image
        width="56"
        height="56"
        x="219"
        y="304"
        transform="rotate(10.4 247 332)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-math" transform="translate(0, -20)">
      {/* UI */}
      <defs>
        <linearGradient
          id="f8da5894-ee4b-4b47-963a-8a330d6a1870"
          x1="389.39"
          y1="227.41"
          x2="366.04"
          y2="494.71"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#663d3c" />
          <stop offset="0.01" stopColor="#663d3c" />
          <stop offset="0.32" stopColor="#794545" />
          <stop offset="0.64" stopColor="#834a4a" />
          <stop offset="1" stopColor="#874c4c" />
        </linearGradient>
        <linearGradient
          id="a6fe2918-3a6e-455c-a2b5-ad02c705d634"
          x1="101.17"
          y1="217.06"
          x2="96.66"
          y2="384.55"
          href="#f8da5894-ee4b-4b47-963a-8a330d6a1870"
        />
        <linearGradient
          id="b2ef88f3-4bb2-4d3d-a1de-a65ef93c5d40"
          x1="224.12"
          y1="272.48"
          x2="195.61"
          y2="598.88"
          href="#f8da5894-ee4b-4b47-963a-8a330d6a1870"
        />
        <linearGradient
          id="a7318841-94d5-4a69-82fe-c00f2853fa3c"
          x1="283.5"
          y1="250.44"
          x2="251.56"
          y2="616.18"
          href="#f8da5894-ee4b-4b47-963a-8a330d6a1870"
        />
      </defs>
      <g
        id="eb6def02-ba55-437d-b423-ec1ceb053756"
        transform="translate(-33, 70)"
      >
        <g id="e0a150b1-3a74-4666-bbbb-69e26489367b">
          <g>
            <path
              d="M8.11,207.27s31,56.67,48.31,82.45c5.81,8.64,11.61-7.21,12.24-4.51.53,2.29,7.32,18.87,13.53,23.84,12.85,10.29,35.43,29,50.89,28.34a86.88,86.88,0,0,1,20.24,16.66l37.1,45.83,48.94-40,17.85,34.84,69.67-57.78,45.85-5.34,26.37-3.16s36.75-116.94,36.12-119.88S407.69,160,407.69,160L323,263.09s16,45.72,12.2,46.7-113.46-22.52-123.54-30.35-5-14.68-5-14.68S185.21,255,167.56,254s-32.15-29.37-43.49-39.15-30.26-3.92-44.75,3.91-29,2-27.74-6.85S8.11,207.27,8.11,207.27Z"
              fill="#874c4c"
            />
            <polygon
              points="399.1 328.44 394.85 291.06 367.66 264.72 361.7 332.11 399.1 328.44"
              fill="url(#f8da5894-ee4b-4b47-963a-8a330d6a1870)"
            />
            <path
              d="M78.32,240.76c10.31-5.8,17.39-8.37,25.12,1.93s9,80.53,16.11,89.55c4.51,5.15-14.17,1.29-27.7-18S78.32,240.76,78.32,240.76Z"
              fill="url(#a6fe2918-3a6e-455c-a2b5-ad02c705d634)"
            />
            <path
              d="M190.08,400.32c6.54-10.9,15.15-81.61,15.15-81.61s27.37,35.37,34.13,41.17C224.92,372.63,190.08,400.32,190.08,400.32Z"
              fill="url(#b2ef88f3-4bb2-4d3d-a1de-a65ef93c5d40)"
            />
            <path
              d="M257.21,394.72c4.83-18.36-.45-78.59-.45-78.59l42.93-10.63Z"
              fill="url(#a7318841-94d5-4a69-82fe-c00f2853fa3c)"
            />
            <path
              d="M105.14,261.74c-.36-4.25.12-8.6-1.08-12.71-3.93-13.45-18.66-8.68-32.25-2.72-6.81,3-18.09-.92-25.29,1.12s-16.69.19-19.29-6.37c-.89-2.24-.84-4.72-1.57-7-1.51-4.73-6-8-9.52-11.7-6.83-7.19-10.22-16.56-13.46-25.66-1.44-4.07-2.9-8.25-2.65-12.53.64-10.92,11.74-18.41,21.73-24.25,18.08-10.56,2.43-21.76,20.51-32.32,21.29-12.43,83.34-8.64,108.39-10.85,27.51-2.44,48.49-7.69,76.12-7.15,25,.48,50.56-7.29,74.63-1,9.44,2.48,60,8,68.53,12.46,19.51,10.29,38.46,15.76,58,26.05,12.39,6.53-16.07,17.09-1.86,18.1,4.63.32,9.5.08,13.63,2,7.51,3.55,9.41,12.89,7.93,20.59s-5.37,14.94-6,22.73c-.24,3.08,0,6.37-1.68,9-4.41,7.08-18.93,5.51-20.89,13.48-.76,3.08.92,6.55-.67,9.33-2.54,4.44-12.21,7.15-8.54,10.84.87.88,2.25,1.11,3.41,1.62,6.45,2.77,4,12.81-2.43,15.59s-14,.86-20.85-.78-14.86-2.75-20.53,1.23c-3.13,2.19-5.33,5.81-9.15,6.63-2.31.49-4.7-.17-7.06-.11-8.61.22-13.28,9.2-16,16.77L375.9,303c5,1.13,7.19,7-4,10.38s-23.08,3.45-34.8,3.53c-51.87.32-105.78,4.58-157.45.08C150.06,314.41,107.69,292.17,105.14,261.74Z"
              fill="#68c902"
            />
            <path
              d="M108.92,249.73c-11.36-5.17-16-1.67-13,1.34S123.09,256.17,108.92,249.73Z"
              fill="#68c902"
            />
            <path
              d="M38.93,251.61l.56-1.36c.6,1.89,3.86,2,4.53.09.85,1.49,2.54,3.21,3.95,2.25.38-.27.63-.69,1-1,1.22-.93,3,.08,4,1.22s2,2.59,3.59,2.64a7.49,7.49,0,0,0,.75-5.27,16.65,16.65,0,0,0,4.37,3.16,15.18,15.18,0,0,0,1-3.92c.92,2.13,4,1.64,6.2.79l9.06-3.57a42.15,42.15,0,0,1,4.2,9.49c-.86-4.3-1.36-9.61,2.16-12.22a45.75,45.75,0,0,0,.72,9.2c5.48-5.28,5.29-14,4.71-21.55a90.65,90.65,0,0,0-9.59,3.08,115.54,115.54,0,0,1-18.25,3.9l-21.36,3.37c-2.24.35-6.6.17-7.05,3.14C33.21,246.84,37.14,251.61,38.93,251.61Z"
              fill="#68c902"
            />
            <ellipse
              cx="271.58"
              cy="297.56"
              rx="30.92"
              ry="8.05"
              fill="#54ba02"
            />
            <path
              d="M271.58,289.51c-14.91,0-27.35,2.74-30.27,6.4,5.27-2.47,15.41-4.15,27.05-4.15,17.08,0,30.92,3.61,30.92,8.05a2.6,2.6,0,0,1-.65,1.65c2.46-1.16,3.87-2.49,3.87-3.9C302.5,293.11,288.66,289.51,271.58,289.51Z"
              fill="#4fb002"
            />
            <ellipse
              cx="221.76"
              cy="305.93"
              rx="17.73"
              ry="4.62"
              fill="#54ba02"
            />
            <path
              d="M221.76,301.32c-8.55,0-15.68,1.57-17.35,3.67,3-1.42,8.83-2.38,15.51-2.38,9.79,0,17.72,2.07,17.72,4.62a1.48,1.48,0,0,1-.37.94c1.41-.66,2.22-1.43,2.22-2.24C239.49,303.38,231.55,301.32,221.76,301.32Z"
              fill="#4fb002"
            />
            <ellipse
              cx="371.65"
              cy="248.38"
              rx="21.47"
              ry="5.59"
              fill="#54ba02"
            />
            <path
              d="M371.65,242.79c-10.36,0-19,1.91-21,4.45,3.67-1.72,10.7-2.88,18.79-2.88,11.86,0,21.47,2.5,21.47,5.59a1.8,1.8,0,0,1-.45,1.14c1.71-.8,2.69-1.72,2.69-2.71C393.12,245.3,383.5,242.79,371.65,242.79Z"
              fill="#4fb002"
            />
            <ellipse
              cx="339.17"
              cy="242.1"
              rx="11.34"
              ry="2.95"
              fill="#54ba02"
            />
            <path
              d="M339.17,239.15c-5.47,0-10,1-11.1,2.35,1.93-.91,5.65-1.52,9.92-1.52,6.26,0,11.33,1.32,11.33,3a1,1,0,0,1-.23.6c.9-.42,1.42-.91,1.42-1.43C350.51,240.47,345.43,239.15,339.17,239.15Z"
              fill="#4fb002"
            />
            <path
              d="M66.46,268.62s-9-.43-10.52,1.08-9.88.43-9.88.43L44.77,265a59.16,59.16,0,0,0-3.65,4.94c-.22.65-1.08,3.44-1.08,3.44L42,279.79l1.29-4.94,3.22.86a26.35,26.35,0,0,1,.86,3.43c0,.65,1.71-3.65,1.71-3.65l2.8,1.08L52.93,274l2.15,1.5.64,4.51,1.93-6.87,1.51,1.51,1.28-2.37,1.94-1.07Z"
              fill="#45a102"
            />
            <path
              d="M208.68,336.59l4,2.93,8,.22,18.64-2s-7.1,3.61-7.74,3.78-12.39,1-12.39,1l-3.06,3.39-1.69-3.23-1.58-.29-.86,4.4-1.93-5.24-3,1.86-.43-3.38Z"
              fill="#45a102"
            />
            <path
              d="M220.2,316.68c5.83,1.41,13.18-.72,19.17-.39,4.35.25,7.57-.31,11.92-.64,30.48-2.31,60.62-.83,91.09-3.13,6.43-.49,12.94-1,19.27.2,1.51.28,3.41,1.28,3,2.76-.3,1.1-1.66,1.43-2.79,1.57l-19.44,2.38a7.72,7.72,0,0,1-3.72,6.85,24,24,0,0,0,.17-6.82c-3.57,1-7.34.89-11,.79l-2.6-.07-15.72-.41,1.32,2.63a31.4,31.4,0,0,0-21.41-.69,42.91,42.91,0,0,1,10.07,3.88,35.23,35.23,0,0,1-20.72-4.38,6.54,6.54,0,0,1-7.24,1.3,5.93,5.93,0,0,1-9-1.09L261.67,333a27.5,27.5,0,0,1-4.76-12.88,6.9,6.9,0,0,1-7.52,2A28.77,28.77,0,0,1,230.18,321c-4-1.65-7.2-4.53-11.48-5.42-6.4-1.33-13.4.54-20-.08a141.06,141.06,0,0,1-19.31-3.67c-9-2.16-21.51-6.92-30.67-4.7.3,3.11,2.83,5.93,5.66,7.16,1.08.47,2.87.3,2.81-.88.63,1.61,1.38,3.36,2.92,4.15s4-.18,3.79-1.9c3.83,3.37,9.77,5,14.09,2.29a6.39,6.39,0,0,0,8.89,1.82l4,8.18A28.85,28.85,0,0,0,195,318.9a3.77,3.77,0,0,0,5.66,1.35c1.71,2.8,5.3,4,8.57,3.75s6.33-1.65,9.3-3l1.11,5.07c1.63-1.43,3.12-3.35,3-5.51a4.41,4.41,0,0,0-.6-1.95"
              fill="#68c902"
            />
            <path
              d="M354.24,287.49a15,15,0,0,0-4.6-4.92l10-1.3-4.16-1.56A50.63,50.63,0,0,0,380,277.55a46,46,0,0,0-11.36-2.94,17.16,17.16,0,0,1,12.82-2.88c3.06.54,7,1.6,8.67-1l5.87,1.89c.61-1-.37-2.14-1.29-2.81-7.57-5.5-17.56-7-26.78-5.45s-17.76,6-25.33,11.53a12.5,12.5,0,0,0-3.38,3.22c-1.84,2.85-5.13,13.63.69,14,3.4.2,2.85-3.52,4.59-4.76C345.14,287.88,353.62,286.44,354.24,287.49Z"
              fill="#68c902"
            />
            <path
              d="M55.83,123.06a7,7,0,0,0,2.89-3.31,6.28,6.28,0,0,0,10.89-5.58l3.1,10.07c5.67-7,13.44-14.78,22.2-12.63a7.57,7.57,0,0,0-8.33,6.75,13.14,13.14,0,0,1,9.87.56,4.24,4.24,0,0,0,2.65-2.45c1,2.34,5,1.45,5.93-.91s0-5-1-7.37a26.1,26.1,0,0,1,9.68,11.68l5.92-3.73c-1.35,1.28,1.93,2.27,3.47,1.24s4.8-.92,4,.75a79.62,79.62,0,0,1,5.12-17.08,32.14,32.14,0,0,0,2.56,15.58,5.88,5.88,0,0,0,2.51-2.75c-.11,1.19,1.41,1.77,2.59,1.92A45.94,45.94,0,0,0,172.57,107l-4.13,7.48a34.15,34.15,0,0,1,20.61-2.57l.19-5.82,10.68,5.08,2.71-3.51a22.58,22.58,0,0,0,5.14,5.54c-2.3,3.86-7.5,4.56-12,4.83q-25,1.5-50.12,2.1c-19.89.48-40,.61-59.61,4.34-9.47,1.8-19,7.27-28.22,8.6-8.53,1.22-11.91-7.14-8.29-14.71A14.62,14.62,0,0,1,55.83,123.06Z"
              fill="#68c902"
            />
            <path
              d="M215.82,107.93c.89.16,1.71.6,2.59.84,5,1.35,9-4,11.42-8.64l2,2.71a3.36,3.36,0,0,0,2.7-1l7.48,5.3a8.68,8.68,0,0,0,8.37-4.19c.06,3.06,4.16,4.42,7.08,3.5s5.29-3.13,8.21-4,7,.47,7.05,3.53l3.37-1.56c-1,.61.49,2,1.66,2a9.32,9.32,0,0,0,8.31-5.72l5,5.51,3.65-2.45a7.33,7.33,0,0,0,3.23,3.89A19.07,19.07,0,0,1,306.37,97a31.45,31.45,0,0,0-3.23,11.5l3.73-3c2.33,2,1.15,6.2-1.45,7.89s-5.91,1.63-9,1.53q-27-.89-54.12-.06c-7.87.24-17.6,2.41-25.31,1.23-2.55-.39-4.47.71-5.69-2.31C210.15,111,212.7,107.38,215.82,107.93Z"
              fill="#68c902"
            />
            <path
              d="M424.75,140.89l-3.61,1-1.41-2.19c.22,1.18-1.52,1.93-2.55,1.31a4.28,4.28,0,0,1-1.61-3.11,25.43,25.43,0,0,1,.05-8.83,18.66,18.66,0,0,0-4.39,7.67l-1.12-2.23-1.93.91c-2.19.12-4.05-3-6-2-.47.23-.83.68-1.34.82-.77.21-1.51-.35-2.13-.83a20.51,20.51,0,0,0-11.11-4.19c3.67,6.23,10.43,9.89,17,12.9,4.7,2.15,27.21,14.22,26.56.8-1,1-3.21,1.43-4.3,2.31C426.66,145.06,424.37,141,424.75,140.89Z"
              fill="#68c902"
            />
            <path
              d="M167.08,351.32c-6,4-11,8-7,17s17,14.65,17,14.65Z"
              fill="#874c4c"
            />
            <path d="M264.08,386.32c3,3,68-44,68-44l-4-9Z" fill="#874c4c" />
            <path d="M255.08,383.32c-7-3-17-11-17-11l6-7Z" fill="#874c4c" />
          </g>
        </g>
        <g id="a6d09016-f266-4549-92ce-aaf80fbf9ea1" data-name="decor6">
          <ellipse cx="408.91" cy="180.32" rx="21.83" ry="10" fill="#55a32a" />
          <g>
            <ellipse
              cx="61.7"
              cy="220.91"
              rx="13.46"
              ry="6.55"
              fill="#55a32a"
            />
            <path
              d="M48.62,223.16c.41,2.05,3.68,4.5,8.79,4.5s8-3.48,7.77-4.91-3.89-9-3.89-9,11.65-2.45,11.24-10-1.22-15.53-13.89-17.37-21,5.51-22.28,12.87,1.64,12.06,6.13,14.1a16.39,16.39,0,0,0,8,1.64Z"
              fill="#ffe94d"
            />
            <path
              d="M65.18,222.75c-.19-1.29-3.23-7.62-3.8-8.8A56.07,56.07,0,0,1,50.45,215l-1.83,8.13c.41,2.05,3.68,4.5,8.79,4.5S65.38,224.18,65.18,222.75Z"
              fill="#ffc74d"
            />
            <path
              d="M50.45,215s4.51,4.15,7.88,3.33S61.38,214,61.38,214,54.22,215,50.45,215Z"
              fill="#df9078"
            />
            <path
              d="M67.1,189.48a18.29,18.29,0,0,0-8.46-3.1c-11-1.6-18.75,3.73-21.42,10,7.62,9.5,15.29,11,25.71,4.54C69.16,197.05,69.14,192.93,67.1,189.48Z"
              fill="#c1d54d"
            />
            <ellipse cx="45.15" cy="202.71" rx="6.4" ry="4.01" fill="#ffffcd" />
            <ellipse cx="46.65" cy="195.63" rx="2.71" ry="1.7" fill="#ffffcd" />
            <ellipse cx="53.41" cy="208.3" rx="2.71" ry="1.7" fill="#ffffcd" />
            <ellipse cx="60.9" cy="193.17" rx="5.19" ry="3.25" fill="#ffffcd" />
            <ellipse
              cx="63.99"
              cy="198.76"
              rx="2.18"
              ry="1.36"
              fill="#ffffcd"
            />
            <path
              d="M72.53,203.75a33.09,33.09,0,0,0-1.13-8c0,2.49-2.33,7.17-4.79,9.85-5.08,5.52-16.15,8.58-25.79,6.82a10.1,10.1,0,0,0,1.67.94,16.39,16.39,0,0,0,8,1.64l0,.1A34,34,0,0,0,61.38,214S72.94,211.31,72.53,203.75Z"
              fill="#ffc14d"
            />
            <path
              d="M70.3,232.18,50.55,232c-.49-.16-1-.34-1.48-.52l.72-.25c0-.12-.08-.16-.12-.08a8.19,8.19,0,0,1,0-1.23,7.11,7.11,0,0,0,.07-.88.73.73,0,0,1,.09.45,4.4,4.4,0,0,1,.1-.74A2,2,0,0,0,50,228a4.66,4.66,0,0,1,.13,2,.92.92,0,0,1,.11-.38v0a7.83,7.83,0,0,0,.17-1.46,2.83,2.83,0,0,1,.17,1.23,6.77,6.77,0,0,1,.3-1.64,4,4,0,0,0,.24-1.74,7.72,7.72,0,0,1,.25,2.84.7.7,0,0,1,.13-.21,1.43,1.43,0,0,0,.25-.95,5.79,5.79,0,0,1,.06,1.53c.08-.19.15-.32.23-.53a5.82,5.82,0,0,0,.34-2.06c0-.21.08-.26.11-.12a6.6,6.6,0,0,1,.09.68,1.67,1.67,0,0,1,.17.91,6.91,6.91,0,0,1,.21-1.5,4.22,4.22,0,0,0,.14-1.56c.13-.08.41,1.59.26,4a2,2,0,0,1,.22-.77.31.31,0,0,0,0,.09,18.62,18.62,0,0,0,.34-3,5.45,5.45,0,0,1,.34,2.51,13.25,13.25,0,0,1,.63-3.34,8.67,8.67,0,0,0,.48-3.55c.23,0,.56,2.36.51,5.79a1.28,1.28,0,0,1,.26-.43,2.81,2.81,0,0,0,.5-1.93,10.82,10.82,0,0,1,.13,3.11c.16-.38.32-.66.47-1.08a11.36,11.36,0,0,0,.69-4.18c0-.43.17-.54.23-.26a17.39,17.39,0,0,1,.08,5.16,22.8,22.8,0,0,1-.39,2.42H58v0c.11-.28.22-.46.32-.75a6.94,6.94,0,0,0,.44-2.62c0-.27.11-.34.14-.16a10.69,10.69,0,0,1,.06,3.24c0,.09,0,.18,0,.27l.61,0c0-.07,0-.15,0-.22a9.74,9.74,0,0,0,.1-1.16,1,1,0,0,1,.11.6,5.24,5.24,0,0,1,.14-1,2.61,2.61,0,0,0,.09-1,6.1,6.1,0,0,1,.16,2.58,1.27,1.27,0,0,1,.15-.5v.06a10.81,10.81,0,0,0,.22-1.93,3.58,3.58,0,0,1,.23,1.62,8.62,8.62,0,0,1,.4-2.16,5.58,5.58,0,0,0,.31-2.3c.15,0,.37,1.53.34,3.75a.68.68,0,0,1,.16-.28,1.85,1.85,0,0,0,.33-1.25,7.49,7.49,0,0,1,.08,2c.1-.24.2-.42.3-.7a7.37,7.37,0,0,0,.45-2.7c0-.28.11-.35.15-.17a11.39,11.39,0,0,1,0,3.34c-.07.59-.15,1.1-.24,1.51h.11a4.89,4.89,0,0,0,.2-.46,4.51,4.51,0,0,0,.29-1.7c0-.17.07-.22.09-.1a6.87,6.87,0,0,1,0,2.1l0,.22a31.63,31.63,0,0,1,8,2C71.29,231.86,70.79,232,70.3,232.18Zm-17.93-1.93v-.34c0,.21-.09.39-.13.55l.08,0C52.34,230.37,52.35,230.3,52.37,230.25Z"
              fill="#68c902"
            />
          </g>
          <g>
            <path
              d="M366,195.57c-2.4,2.75-7.2,5-9.21,3.21s-.47-6.81,1.93-9.56,4.76-2.17,6.77-.42S368.41,192.81,366,195.57Z"
              fill="#e4f6fb"
            />
            <path
              d="M365.34,206.56c-3.63-.49-8.12-3.27-7.77-5.92s5.42-4.14,9.05-3.66,4.44,2.78,4.08,5.42S369,207,365.34,206.56Z"
              fill="#e4f6fb"
            />
            <path
              d="M355.15,210.49c-1.31-3.41-1-8.69,1.48-9.65s6.23,2.78,7.54,6.2-.31,5.22-2.8,6.17S356.46,213.91,355.15,210.49Z"
              fill="#e4f6fb"
            />
            <path
              d="M348.05,199.8c3.25-1.68,8.53-2,9.75.39s-2.06,6.51-5.3,8.19-5.23.27-6.46-2.1S344.8,201.48,348.05,199.8Z"
              fill="#e4f6fb"
            />
            <path
              d="M354.52,190.5c3,2.1,5.69,6.65,4.15,8.83s-6.72,1.17-9.71-.94-2.66-4.51-1.12-6.69S351.53,188.39,354.52,190.5Z"
              fill="#e4f6fb"
            />
            <circle cx="357.35" cy="199.6" r="3.87" fill="#feaf26" />
          </g>
          <g>
            <path
              d="M331,219.44c-1.49,1.71-4.47,3.08-5.72,2s-.29-4.23,1.2-5.94,3-1.35,4.2-.26S332.47,217.73,331,219.44Z"
              fill="#e4f6fb"
            />
            <path
              d="M330.57,226.26c-2.25-.3-5-2-4.82-3.67s3.36-2.57,5.61-2.27,2.76,1.72,2.54,3.36S332.82,226.56,330.57,226.26Z"
              fill="#e4f6fb"
            />
            <path
              d="M324.24,228.71c-.81-2.12-.63-5.4.92-6s3.87,1.72,4.68,3.84-.19,3.24-1.74,3.84S325.05,230.83,324.24,228.71Z"
              fill="#e4f6fb"
            />
            <path
              d="M319.83,222.07c2-1,5.3-1.23,6.06.24s-1.28,4-3.3,5.08-3.24.17-4-1.3S317.82,223.11,319.83,222.07Z"
              fill="#e4f6fb"
            />
            <path
              d="M323.85,216.29c1.86,1.31,3.53,4.13,2.58,5.48s-4.18.73-6-.58-1.65-2.8-.7-4.15S322,215,323.85,216.29Z"
              fill="#e4f6fb"
            />
            <circle cx="325.61" cy="221.94" r="2.4" fill="#feaf26" />
          </g>
          <path
            d="M353.17,158.35a10.34,10.34,0,0,1-.14-3.72l1.38,2a4,4,0,0,1,1.56-1.69,9,9,0,0,0,2.32,2.55L360.2,156a1.81,1.81,0,0,0,2.31,1.31,5.22,5.22,0,0,0,2.37-1.81l.9,2a6.21,6.21,0,0,0,2.23-1.37,1.89,1.89,0,0,0,.67,1.68,36.1,36.1,0,0,1,11.55-17.46A51.28,51.28,0,0,0,369,163.68a22.75,22.75,0,0,1,7-7.16,1.36,1.36,0,0,0,.07,2,102.63,102.63,0,0,1-7,12,34.19,34.19,0,0,0-3.54-10l-1.61,2.37a3.75,3.75,0,0,1-1.83-1.61,3.45,3.45,0,0,0-1.87-1.55c-.81-.17-1.81.59-1.52,1.37-1.35-1.21-2.67-2.53-4.11-3.59-.19,2.13.42,4.76-.32,6.74-3.28-2.71-3.88-9.87-5.83-13.58C350,153.23,351.58,155.8,353.17,158.35Z"
            fill="#55a32a"
          />
        </g>
        <g id="ace1a2e9-9944-4761-9667-4a0497e9529d" data-name="math-text">
          <g>
            <path
              d="M238.76,260.6c-.23-1.42-.49-2.84-.76-4.24s-.6-2.83-1-4.25c-.24,1.31-.54,2.62-.88,3.91s-.73,2.6-1.19,3.89a2.12,2.12,0,0,1-.38.69,1.29,1.29,0,0,1-.69.35,7.32,7.32,0,0,1-1.49.17,1.83,1.83,0,0,1-1-.25,1.54,1.54,0,0,1-.53-.77,37.42,37.42,0,0,1-1.24-3.94c-.34-1.33-.68-2.68-1-4.05-.31,1.23-.56,2.51-.77,3.85s-.41,2.78-.6,4.33a1.64,1.64,0,0,1-.25.8q-.18.27-.87.27a8.6,8.6,0,0,1-1.05-.05c-.32,0-.62-.08-.91-.13a.85.85,0,0,1-.81-.89,1.48,1.48,0,0,1,0-.21c0-.07,0-.14,0-.23a60.77,60.77,0,0,1,1.27-6.14c.54-2,1.15-4.12,1.86-6.28a1.71,1.71,0,0,1,.39-.68,1.52,1.52,0,0,1,.79-.29l.67-.06c.21,0,.42,0,.63,0h.31a1.37,1.37,0,0,1,.29,0,1.47,1.47,0,0,1,.75.27,1.86,1.86,0,0,1,.51.76,35.71,35.71,0,0,1,1.23,3.36c.34,1.13.68,2.29,1,3.49.26-1.14.54-2.29.84-3.44a22.4,22.4,0,0,1,1.17-3.43,1.49,1.49,0,0,1,1.28-.93l.67-.06.61,0h.3l.28,0a1.41,1.41,0,0,1,.82.32,2,2,0,0,1,.49.82,56.1,56.1,0,0,1,1.9,6.06A62.06,62.06,0,0,1,242.7,260a2.16,2.16,0,0,1,0,.31.76.76,0,0,1-.58.83,6.32,6.32,0,0,1-1,.2,7.22,7.22,0,0,1-1,.07,2.71,2.71,0,0,1-.88-.12C239,261.22,238.83,261,238.76,260.6Z"
              fill="#fff"
            />
            <path
              d="M251.6,261.3c-.39-.05-.63-.16-.71-.31a1.5,1.5,0,0,1-.12-.68,5.66,5.66,0,0,1-1.47.83,4.9,4.9,0,0,1-1.68.29,4.78,4.78,0,0,1-1.78-.32,4.05,4.05,0,0,1-1.34-.9,3.81,3.81,0,0,1-.85-1.37,4.82,4.82,0,0,1-.29-1.72,6,6,0,0,1,.51-2.46,6.67,6.67,0,0,1,1.33-2,6.13,6.13,0,0,1,1.88-1.33,5.09,5.09,0,0,1,2.18-.49,4.56,4.56,0,0,1,1.82.37,1,1,0,0,1,.16-.53.57.57,0,0,1,.42-.13,7.91,7.91,0,0,1,.93.08,8.21,8.21,0,0,1,1.08.23,3.11,3.11,0,0,1,.43.14,1,1,0,0,1,.31.23,1,1,0,0,1,.18.37,3.28,3.28,0,0,1,0,.6c0,1.23,0,2.54-.1,3.92s-.18,2.7-.34,4a1.62,1.62,0,0,1-.3.86,1.1,1.1,0,0,1-.75.32,1.82,1.82,0,0,1-.42,0h-.81A1.57,1.57,0,0,1,251.6,261.3Zm-.67-3.95c0-.53.06-1.06.09-1.62l.06-1.63a5,5,0,0,0-.62-.21,3.38,3.38,0,0,0-.75-.08,2.18,2.18,0,0,0-1.11.28,2.85,2.85,0,0,0-.81.69,3.31,3.31,0,0,0-.51.89,2.56,2.56,0,0,0-.18.89,1.64,1.64,0,0,0,.47,1.24,1.82,1.82,0,0,0,1.34.46,2.55,2.55,0,0,0,1-.22A2.87,2.87,0,0,0,250.93,257.35Z"
              fill="#fff"
            />
            <path
              d="M255.76,252.86a2.14,2.14,0,0,1,.05-.56A.6.6,0,0,1,256,252a.87.87,0,0,1,.4-.18l.66-.09v-.58c0-.26,0-.53,0-.79s0-.54,0-.85a2.36,2.36,0,0,1,.12-.66.79.79,0,0,1,.38-.43,2.33,2.33,0,0,1,.84-.25,9.65,9.65,0,0,1,1.5-.09.78.78,0,0,1,.66.24,1.14,1.14,0,0,1,.19.7c0,.06,0,.19,0,.38s0,.41,0,.67,0,.54,0,.82,0,.55,0,.8l.72.07.73.09a.9.9,0,0,1,.58.26.94.94,0,0,1,.17.61,4.27,4.27,0,0,1,0,.55c0,.23,0,.44-.07.63a.86.86,0,0,1-.29.57,1.39,1.39,0,0,1-.66.2c-.19,0-.4.05-.61.06l-.49,0c0,.46,0,1,.06,1.57s.06,1.17.1,1.72.06,1.05.08,1.49,0,.73,0,.87a.87.87,0,0,1-.15.56,1,1,0,0,1-.59.25,10.51,10.51,0,0,1-1.58.12.9.9,0,0,1-.59-.17,1.11,1.11,0,0,1-.25-.68c-.14-1-.26-1.94-.35-2.89s-.17-1.94-.23-3l-.54-.07a1.17,1.17,0,0,1-.63-.19.88.88,0,0,1-.24-.63,3.67,3.67,0,0,1,0-.46C255.76,253.1,255.76,253,255.76,252.86Z"
              fill="#fff"
            />
            <path
              d="M264,247.79a5,5,0,0,1,.1-.8.58.58,0,0,1,.48-.43c.17,0,.36-.07.58-.1l.69-.07.7,0c.23,0,.43,0,.6,0s.36.05.41.15a.86.86,0,0,1,.09.43c0,.12,0,.36,0,.72s0,.77-.05,1.23,0,1,0,1.49,0,1,0,1.5a5.25,5.25,0,0,1,1.61-.79,5.84,5.84,0,0,1,1.77-.26,6.14,6.14,0,0,1,1,.09,3,3,0,0,1,1,.39,2.39,2.39,0,0,1,.83.89,3.15,3.15,0,0,1,.35,1.59c0,.37,0,.8,0,1.3s0,1-.08,1.6-.08,1.17-.14,1.8-.14,1.23-.22,1.84a1.82,1.82,0,0,1-.2.65q-.15.3-.69.3c-.19,0-.46,0-.81-.05a8.92,8.92,0,0,1-1-.16.81.81,0,0,1-.66-.91c0-.15,0-.67.11-1.55s.11-2.06.11-3.54a1.46,1.46,0,0,0-.19-.8.66.66,0,0,0-.59-.3,4.16,4.16,0,0,0-2.22.77c0,1.06,0,2.06.06,3s.08,1.7.15,2.32l0,.23a1.27,1.27,0,0,1,0,.2.65.65,0,0,1-.22.54,1.61,1.61,0,0,1-.88.23l-.32,0h-.71l-.31,0a1.19,1.19,0,0,1-.84-.29,1.53,1.53,0,0,1-.26-.75c0-.42-.08-.93-.13-1.52s-.09-1.23-.13-1.92-.06-1.43-.08-2.19,0-1.53,0-2.32,0-1.51.05-2.25S264,248.49,264,247.79Z"
              fill="#fff"
            />
          </g>
        </g>
      </g>
      {/* LINKS */}
      {resources && (
        <g className="resources-wrap" transform="translate(-5, -60)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
      <g
        id="b33bf893-167c-4678-b86f-a3df266cceeb"
        data-name="flag math"
        transform="translate(-32, 71)"
      >
        <g>
          <path
            d="M415,180.62c0,3.43-6.28,6.21-14,6.21s-14-2.78-14-6.21c0-.71.05-2.78.05-2.78s7.83-3.42,14-3.42,14,3.36,14,3.36S415,179.88,415,180.62Z"
            fill="#8abcf8"
          />
          <ellipse cx="400.93" cy="178.02" rx="14.02" ry="6.2" fill="#9ae1f8" />
          <path
            d="M400.48,176.48C401.63,177.53,412,174,412,174s-3.87-1.44-4.56-1.62a40.85,40.85,0,0,0-8.08,2.48Z"
            fill="#8aa6f8"
          />
          <path
            d="M401.12,177.13h-2.28V21.47L400.92,0,403,21.47V175.23A1.9,1.9,0,0,1,401.12,177.13Z"
            fill="#9ae1f8"
          />
          <path
            d="M400.92,0l-1,9.88,1.15,11.76V177.13h0a1.9,1.9,0,0,0,1.91-1.91V21.47Z"
            fill="#8abcf8"
          />
          <rect
            x="367.61"
            y="50.1"
            width="66.04"
            height="3.58"
            rx="1.79"
            transform="translate(-2.84 72.14) rotate(-10.25)"
            fill="#9ae1f8"
          />
          <path
            d="M378,57.84s6,13.13,7.17,21.48-5.37,30.42,0,46.52,29.22,27.43,29.22,27.43l12.52-22.06,31.61,7.15s-16.1-11.92-18.49-28S440,74,437,65,426.86,48.9,426.86,48.9Z"
            fill="#e11e52"
          />
          <path
            d="M377.66,54.21a2.43,2.43,0,0,1,.31,3.64c6.8-1.2,16.7-3,16.7-3s1.78-2.2-.6-3.58C388.59,52.08,377.66,54.21,377.66,54.21Z"
            fill="#b71e6e"
          />
          <path
            d="M410.16,48.25a2.43,2.43,0,0,1,.31,3.64l16.7-3s1.78-2.19-.59-3.57C421.1,46.11,410.16,48.25,410.16,48.25Z"
            fill="#b71e6e"
          />
          <path
            d="M398.84,21.47V32a4.19,4.19,0,0,0,2.6.56c.41,0,1.18-.22,1.58-.26V21.47L400.92,0Z"
            fill="#cfdff1"
          />
          <path
            d="M433.82,115.69c2.59-.3,5-.52,7.27-.67a30.48,30.48,0,0,1-1.1-4.69C437.61,94.23,440,74,437,65c-.13-.4-.28-.8-.43-1.19-4.29,4.75-21.1,14.26-31.59,16.29-9.9,1.91-15.57,4.09-20.61,12.09-1.18,10.11-2.75,23.14.75,33.64a23.32,23.32,0,0,0,1.29,3.12C397.48,128.47,422,117.08,433.82,115.69Z"
            fill="#cb1e52"
          />
          <g>
            <path
              d="M393,87.46a1,1,0,0,1,1,.34,3.27,3.27,0,0,1,.31,1.39q.13,3.23.19,6.24c0,2,.09,4,.13,6q0,1.59,0,3.12v6.28c0,1,0,2.13,0,3.22a4.34,4.34,0,0,1-.23,1.62,1.93,1.93,0,0,1-1.13.87,17.6,17.6,0,0,1-2.85.79,1.17,1.17,0,0,1-1.23-.26,2.47,2.47,0,0,1-.4-1.33q-.22-3.41-.35-6.57t-.12-6.31c0-2,0-4,0-6s.09-4.09.18-6.26a3.45,3.45,0,0,1,.31-1.4,2.19,2.19,0,0,1,.87-.79,7.86,7.86,0,0,1,1.93-.77A8.19,8.19,0,0,1,393,87.46Z"
              fill="#ffdc05"
            />
            <path
              d="M414.6,89a10.73,10.73,0,0,1-.74,3.31,46.66,46.66,0,0,1-1.93,4.65q-1.21,2.57-2.71,5.37t-3,5.43l5.42-1.36.58-.14L413,106l.7-.19.5-.12a1.14,1.14,0,0,1,.95.11,1.37,1.37,0,0,1,.41.87,10.1,10.1,0,0,1,.15,1.85,16.68,16.68,0,0,1-.14,2.16,2.73,2.73,0,0,1-.45,1.26,2.09,2.09,0,0,1-1,.59c-1.43.41-2.75.79-4,1.12s-2.48.63-3.8.88c-.82.16-1.71.31-2.69.47s-2,.29-3.21.4a1.57,1.57,0,0,1-1-.22,1.46,1.46,0,0,1-.53-1.06c0-.38-.08-.77-.11-1.16a12,12,0,0,1-.05-1.22v-.61q0-.32,0-.66a5,5,0,0,1,.19-1.29,7.53,7.53,0,0,1,.66-1.34q2.25-3.81,4.41-7.76t4.15-8.5a14.64,14.64,0,0,0-3.69-.49,25.83,25.83,0,0,0-3.94.27c-.73.09-1.09-.18-1.09-.8,0-.08,0-.19,0-.32a6.27,6.27,0,0,1,.15-.77c.12-.51.27-1.11.46-1.8s.42-1.41.67-2.15a2.46,2.46,0,0,1,.54-1,2.72,2.72,0,0,1,1.23-.55c.37-.09.86-.19,1.48-.29a19.91,19.91,0,0,1,2-.18c.73,0,1.48,0,2.26,0a12,12,0,0,1,2.27.37,5.85,5.85,0,0,1,2.88,1.67A4.85,4.85,0,0,1,414.6,89Z"
              fill="#33c0f1"
            />
            <path
              d="M436.52,97a9.2,9.2,0,0,1-1.59,5,21.53,21.53,0,0,1-4.14,4.72c-.61.5-1.23,1-1.87,1.46s-1.27.89-1.88,1.28-1.2.72-1.74,1-1,.54-1.45.74l-1.24.57a5.78,5.78,0,0,1-.83.31,1.45,1.45,0,0,1-.9-.11,2.22,2.22,0,0,1-.83-.88,17.37,17.37,0,0,1-.93-1.51,8.44,8.44,0,0,1-.72-1.9,3.06,3.06,0,0,1-.14-.89,1.73,1.73,0,0,1,1.31-1.62,23.74,23.74,0,0,0,2.58-1.19c.93-.48,1.83-1,2.71-1.54a26.83,26.83,0,0,0,2.48-1.76,15.91,15.91,0,0,0,2-1.81,3.29,3.29,0,0,0-2.35-1.13,11.8,11.8,0,0,0-3.37.31l-.61.15c-.21.06-.53.13-.94.22a1.88,1.88,0,0,1-1.09,0c-.3-.13-.52-.54-.64-1.25a9.19,9.19,0,0,1-.11-1.42c0-.32,0-.64,0-1s.06-.64.11-1a2.84,2.84,0,0,1,.53-1.41,4.55,4.55,0,0,1,1.12-.76,17.09,17.09,0,0,0,3.66-2.24,10.75,10.75,0,0,0,2.47-2.87,8.25,8.25,0,0,0-2.4-.11,18.25,18.25,0,0,0-2.56.43,20.84,20.84,0,0,0-2.26.63,12.24,12.24,0,0,1-1.37.43.79.79,0,0,1-.64-.09c-.18-.11-.27-.38-.27-.78a3.74,3.74,0,0,1,.11-.86c.19-.8.41-1.58.67-2.34a15.24,15.24,0,0,1,.89-2.14,4.67,4.67,0,0,1,1-1.47,4.52,4.52,0,0,1,1.27-.67c.27-.09.55-.18.83-.25l.83-.2a21.79,21.79,0,0,1,4.14-.63,11,11,0,0,1,3.52.34,5.12,5.12,0,0,1,2.45,1.44,3.87,3.87,0,0,1,.93,2.72,8.31,8.31,0,0,1-.32,2.32,10.14,10.14,0,0,1-1,2.36,12.19,12.19,0,0,1-1.6,2.2,9.41,9.41,0,0,1-2.2,1.76,9,9,0,0,1,4.68,2A4.56,4.56,0,0,1,436.52,97Z"
              fill="#fd8eba"
            />
          </g>
          <path
            d="M433.16,46.22l-.07-.42a1.58,1.58,0,0,0-1.84-1.27l-.13,0a.83.83,0,0,1,.06.21l.08.42A1.58,1.58,0,0,1,430,47L368.24,58.18A1.56,1.56,0,0,0,370,59.24l61.88-11.19A1.57,1.57,0,0,0,433.16,46.22Z"
            fill="#9ae1f8"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M400.92,0l-.45,4.62L402,20l.2,11.23a13.11,13.11,0,0,1-1.76.06,7.94,7.94,0,0,1-1.58-.29v1a4.19,4.19,0,0,0,2.6.56c.41,0,1.18-.22,1.58-.26V21.47Z"
            fill="#bad2f1"
          />
          <path
            d="M403.22,31.7c0,.53-1,.95-2.28.95s-2.27-.42-2.27-.95"
            fill="none"
            stroke="#cfdff1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <g transform="translate(-30, 80)">
        <ellipse cx="181.77" cy="279.09" rx="10.64" ry="4.66" fill="#55a32a" />
        <path
          d="M174.39,234.54c-.16,3.12.33,10.34-1.8,14.77s-5.42,6.57-3.12,12.48,2.13,13.95,1.64,15.76-.66,2.46-.66,2.46a2.21,2.21,0,0,0,2.3.9c1.64-.25,2.55-2.46,2.63-3.69a45.89,45.89,0,0,0-.25-13,50.63,50.63,0,0,1-1.31-11.08c-.08-3.61,1.56-5.74,2.05-8.45s.9-10,.9-10,5.5.65,6.16-.09c.65-1.64.41-7.22-6.57-6.89s-8.45,5.09-8.12,6.4S174.39,234.54,174.39,234.54Z"
          fill="#e53666"
        />
        <path
          d="M176.77,234.71s5.5.65,6.16-.09c.65-1.64.41-7.22-6.57-6.89s-8.45,5.09-8.12,6.4,6.15.41,6.15.41v.16a8.64,8.64,0,0,1,1.15.09l1.22.17C176.77,234.8,176.77,234.71,176.77,234.71Z"
          fill="#e53666"
        />
        <path
          d="M174.39,234.54a7,7,0,0,1,2.38.17s-.49,9.11-1,10.58C175.05,235.86,174.39,234.54,174.39,234.54Z"
          fill="#bb3666"
        />
        <path
          d="M173.41,283.62c0,1.64,1.64,2.38,3.53,2.62s5.09-.24,5.25-1.47,0-22.57-.49-23.64c1.47-.33,5.17-1.56,4.92-4.1s-1.8-6.07-7-6.57-8.87,2.06-8.38,5.42,5.26,5.33,5.26,5.33a51.3,51.3,0,0,1,.74,8.46C177.35,274.92,173.41,283.62,173.41,283.62Z"
          fill="#a77de8"
        />
        <path
          d="M175.13,227.73c-1.54.26-4.1,1.15-4.84,2.38s2.71,2.3,5.33,2,6.16.58,6.41-1-.33-2.46-2.06-3A10.12,10.12,0,0,0,175.13,227.73Z"
          fill="#e5679f"
        />
        <ellipse cx="172.42" cy="231.86" rx="1.64" ry="0.82" fill="#e5d7b1" />
        <ellipse cx="174.23" cy="230.52" rx="0.78" ry="0.39" fill="#e5d7b1" />
        <ellipse cx="171.6" cy="230.28" rx="1.06" ry="0.53" fill="#e5d7b1" />
        <ellipse cx="179.1" cy="232.44" rx="1.5" ry="0.75" fill="#e5d7b1" />
        <ellipse cx="180.96" cy="231.11" rx="0.65" ry="0.33" fill="#e5d7b1" />
        <ellipse cx="176.63" cy="229.09" rx="1.39" ry="0.7" fill="#e5d7b1" />
        <path
          d="M176.94,286.24c1.88.25,5.09-.24,5.25-1.47s0-21.14-.44-23.46c-1.94,0-4.46-.24-5.84-.39.37.19.62.29.62.29a51.3,51.3,0,0,1,.74,8.46c.08,5.25-3.86,13.95-3.86,13.95C173.41,285.26,175.05,286,176.94,286.24Z"
          fill="#8a6ce8"
        />
        <path
          d="M181.73,261.25a1,1,0,0,0,0-.12c1.47-.33,5.17-1.56,4.92-4.1a7.62,7.62,0,0,0-1.33-3.66c-.15,4.81-6.3,6.94-12.79,5a11.63,11.63,0,0,0,3.38,2.54c.39.19.65.3.65.3S179.14,261.37,181.73,261.25Z"
          fill="#7b5dce"
        />
        <path
          d="M176.53,261.21s2.71,2.59,4.14,2.14,1-2.22,1-2.22S177.14,261.3,176.53,261.21Z"
          fill="#5641ce"
        />
        <ellipse cx="175.6" cy="255.66" rx="2.79" ry="1.2" fill="#e59be8" />
        <ellipse cx="177.51" cy="252.87" rx="1.24" ry="0.54" fill="#e59be8" />
        <ellipse cx="180.52" cy="255.66" rx="1.24" ry="0.54" fill="#e59be8" />
        <path
          d="M189.64,305.87H171.91c-.44-.64-.88-1.32-1.33-2,.22-.35.43-.68.65-1,0-.48-.08-.64-.12-.33,0-.37-.07-3.12,0-4.91s.07-3,0-3.53a11.77,11.77,0,0,1,.09,1.81c0-1.31,0-2.34.08-3s.1-2.1.06-3.06c0-.16.18,3.11.13,7.83a11.65,11.65,0,0,1,.1-1.52v.18c.09-2.87.16-4.83.13-5.87a45.75,45.75,0,0,1,.17,4.92c.05-3.07.15-5.34.25-6.57a69.89,69.89,0,0,0,.2-7c.1,0,.26,4.63.26,11.38a5.56,5.56,0,0,1,.11-.87,22.21,22.21,0,0,0,.21-3.8c.05.36.09,2.84.07,6.11.07-.75.14-1.29.2-2.14.26-3.41.26-4.69.29-8.22,0-.84.07-1.06.09-.51,0,.84.07,1.75.09,2.71a27.46,27.46,0,0,1,.16,3.66c0-2.67.09-4.77.17-6s.2-4.27.12-6.23c.12-.33.38,6.34.27,15.95.06-2.06.15-2.74.19-3.09v.35c.19-5.84.34-9.83.28-11.95a92.16,92.16,0,0,1,.34,10c.11-6.25.31-10.87.52-13.38s.56-8.95.4-14.24c.21,0,.53,9.42.52,23.16a13.69,13.69,0,0,1,.23-1.76,44.44,44.44,0,0,0,.43-7.74c.11.72.2,5.78.14,12.45.14-1.53.28-2.65.41-4.36.53-7,.54-9.56.58-16.74,0-1.72.15-2.16.21-1,.26,5.6.31,12.6.12,20.64-.09,3.82-.2,7-.33,9.68l.16-.05s0-.06,0-.08c.09-1.09.19-1.82.28-3,.33-4.38.33-6,.36-10.53,0-1.07.1-1.36.13-.65.16,3.52.2,7.91.08,13,0,.37,0,.71,0,1.07a5,5,0,0,1,.54-.08c0-.31,0-.61,0-.89,0-2.37.09-4,.07-4.64a18.53,18.53,0,0,1,.11,2.38c0-1.72.06-3.08.11-3.9s.13-2.77.08-4c.07-.21.24,4.11.17,10.32,0-1.33.1-1.77.12-2V293c.12-3.78.22-6.36.19-7.73a60.76,60.76,0,0,1,.21,6.48c.07-4,.2-7,.34-8.65s.36-5.8.26-9.22c.13,0,.34,6.1.33,15a9.13,9.13,0,0,1,.15-1.15,28.09,28.09,0,0,0,.28-5c.07.47.13,3.74.09,8.05.09-1,.18-1.71.27-2.81.34-4.51.34-6.19.37-10.83,0-1.11.1-1.4.13-.68.17,3.63.21,8.15.09,13.35q-.09,3.57-.21,6.07l.11,0c.06-.66.12-1.13.17-1.86.21-2.83.22-3.89.24-6.81,0-.69.06-.88.08-.42.11,2.28.13,5.12.05,8.39,0,.31,0,.61,0,.9,2.78,1.22,4.92,4.13,7.2,7.78C190.52,304.55,190.08,305.23,189.64,305.87Zm-16.11-7c0-.44,0-.89,0-1.34,0,.82-.07,1.55-.1,2.19l.07-.09C173.5,299.38,173.52,299.12,173.53,298.89Z"
          fill="#68c902"
        />
      </g>
    </g>
  );
};
export default MathLink;
